import { Component, OnInit } from '@angular/core';
import { logbaseService } from '../../services/logbase.service';
//import { forEach } from '@angular/router/src/utils/collection';
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { timeout } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator} from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
export interface SpcExceptionData{
  deliveryPoint:any;
  action:any;

}

@Component({
  selector: 'app-spc-config',
  templateUrl: './spc-config.component.html',
  styleUrls: ['./spc-config.component.scss']
})
export class SpcConfigComponent implements OnInit {

  newSupplierCode: any;
  contract: any;
  paidOpt: any;
  supplierNameEng: any;
  userIDTaken: any;
  addSupplierCode: any;
  valuechange: any;
  delPoints: any = [];
  delPointOpt: any;
  plantNames: any = [];
  plantNameOpt: any[];
  delPoint: any;
  description: any;
  plantName: any;

  addConfigBtn: boolean;
  modalRef: NgbModalRef;

  public rows: Array<any> = [];


  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;
  private data: Array<any> = [];
  exceptionList: any;
  spcExpListData: any[];

  displayedColumns = ['deliveryPoint', 'action'];
 
  dataSource: MatTableDataSource<SpcExceptionData[]>;



  @ViewChild('deleteDetails') deleteDetails: ElementRef;
  currentRow: any;

  constructor(private spinner: NgxSpinnerService, private logbaseService: logbaseService, private modalService: NgbModal, private toastr: ToastrService) { }

  ngOnInit() {

    this.addConfigBtn = true;
    this.getDeliveryPoints();
    this.onChangeTable(this.config, true);
    this.spinner.show();

  }

  enableConfigBtn(event) {
    if ((this.delPoint != undefined && this.delPoint != 0)) {
      this.addConfigBtn = false;
    } else {
      this.addConfigBtn = true;
    }
  }

  public columns: Array<any> = [
    { title: 'Delivery Point', name: 'nouba' },
    { title: 'Action', name: 'action' }
  ];
  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== "" && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === "desc" ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === "asc" ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(
          this.config.filtering.filterString
        )
      );
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name]) {
          if (
            item[column.name].toString().match(this.config.filtering.filterString)
          ) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    var pageNo;
    var sortData;

    if (page.page == undefined) {
      pageNo = this.page - 1;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != "") {
        sortData = {
          name: value.name,
          sort: value.sort
        };
      }
    });

    var dataToSend = {
      pageNum: pageNo,
      size: this.itemsPerPage,
      sortType: sortData.sort
    };

    this.logbaseService.getSPCException(dataToSend).subscribe(result => {
      this.exceptionList = result;
      var expArr;
      var expData = [];

      this.exceptionList.response.content.forEach(function (value, key) {

        expArr = {
          nouba: value.id,
          action: '<div class="hasLink text-center">Delete</div>'
        };

        expData.push(expArr);
      });

      this.spcExpListData = expData;
      this.dataSource=new MatTableDataSource<SpcExceptionData[]>(this.spcExpListData)

      this.data = expData;
      this.length = this.exceptionList.response.totalElements;

      let filteredData = this.changeFilter(this.data, this.config);
      let sortedData = this.changeSort(filteredData, this.config);
      this.rows =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;
      //this.length = sortedData.length;

      this.rerenderTable(this.config, true);
      //this.ref.detectChanges();
      this.spinner.hide();
    });

  }

  public rerenderTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows =
      page && config.paging ? this.changePage(page, sortedData) : sortedData;
    //this.length = sortedData.length;
  }

  getDeliveryPoints() {
    var delPtsOpt = [];
    this.logbaseService.getDeliveryPoints().subscribe(result => {
      this.delPoints = result.response;
      this.delPoints.forEach(function (value, key) {
        delPtsOpt.push(value.deliveryPoint);
      });

      this.delPointOpt = delPtsOpt;
    });
  }

  // onDPChange(event) {
  //   var plantOpt = [];
  //   this.logbaseService.fetchPlantPO().subscribe(result => {
  //     this.plantNames = result;

  //     this.plantNames.response.forEach(function (value, key) {
  //       plantOpt.push(value);
  //     });

  //     this.plantNameOpt = plantOpt;
  //   });
  // }

  addException() {
    var dataToSend = {
      deliveryPoint: this.delPoint
    }

    if (this.spcExpListData.some((item) => item.nouba == this.delPoint)) {
      this.toastr.error('Delivery point already exists in exception list!');
    } else {
      this.logbaseService.addSuppCodeException(dataToSend).subscribe(result => {
        this.toastr.success(this.delPoint + ' added in the exception list successfully!');
        // After successful post response, make all input empty
        this.delPoint = null;
        this.onChangeTable(this.config, true);
      });
    }
  }

  deleteRowDetails() {
    this.modalRef.close();
    var dataToSend = {
      "deliveryPoint": this.currentRow.row.nouba
    }

    this.logbaseService.delSPCException(dataToSend).subscribe(result => {

      this.toastr.success(this.currentRow.row.nouba + ' deleted from the exception list successfully!');

      this.onChangeTable(this.config, true);

    });
  }

  onCellClick(data: any) {
    console.log("event",data)
    this.currentRow = data;
    // if (data.column == "action") {
    //   this.modalRef = this.modalService.open(this.deleteDetails);
    // }
    this.modalRef = this.modalService.open(this.deleteDetails,{backdrop:false});
  }

  
}
